import { handleActions } from 'redux-actions';
import { FiltersState } from './interfaces';
import Types from './types';

const initialState: FiltersState = {
  isLoading: false,
  filters: [],
  clientsFilters: [],
};

export default handleActions(
  {
    [Types.SET_FILTER_VALUES]: (state: FiltersState, { payload }) => ({
      ...state,
      isLoading: false,
      filters: payload,
    }),
  },
  {
    [Types.SET_CLIENTS_FILTER_VALUES]: (state: FiltersState, { payload }) => ({
      ...state,
      isLoading: false,
      clientsFilters: payload,
    }),
  },
  initialState
);
